export const InternalChatTestIds = {
  BACK: 'internal-chat.back-button',
};
